import { Box, Breadcrumbs, Container, Link, Typography } from "@mui/material"
import PartnerSlider from "../components/PartnerSlider"
import { useSelector } from "react-redux"
import { Link as RouterLink } from "react-router-dom";
import { RootState } from "../../../redux/store"
import PageLang from "../../../config/page.languge"

const CopyrightPolicy = () => {
    const language = useSelector((state: RootState) => state.language.language);
    return (
        <>
            <Box sx={{ backgroundImage: "url('images/heading.png')", backgroundSize: "cover", backgroundPosition: "center", height: '150px', display: 'flex', alignItems: 'center' }}>
                <Container sx={{ pb: 3, mt: { xs: 13, sm: 3 } }}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link
                            component={RouterLink}
                            to="/"
                            underline="hover"
                            color="inherit"
                            sx={{ textDecoration: 'none' }}
                        >
                            <Typography variant="h4" sx={{ color: 'text.light' }} >{PageLang?.homeTitle[language]}</Typography>
                        </Link>
                        <Typography variant="h4" sx={{ color: 'text.secondary' }}>{PageLang?.copyrightTitle[language]}</Typography>
                    </Breadcrumbs>
                </Container>
            </Box>
            <Container sx={{ pb: 3, mt: 3 }}>
                <Box sx={{}}>
                    <Typography variant="h6" sx={{ color: '#000', textAlign: 'justify' }}>
                        {PageLang?.copyrightPolicy[language]}
                    </Typography>
                </Box>
                <Box sx={{ width: "100%", py: 2, backgroundColor: "background.paper" }}>
                    <PartnerSlider />
                </Box>
            </Container>
        </>
    )
}
export default CopyrightPolicy